var React = require('react');
import Tooltip from '../Tooltip';
import tooltipDescriptions from '../TooltipDescriptions';
const costMappings = JSON.parse(document.getElementById('cost-mappings').getAttribute('data_value'));

class WaterChemistryOption extends React.Component {

    constructor() {
        super();
        this.checkboxClick = this.checkboxClick.bind(this);
        this.checkboxPlusClick = this.checkboxPlusClick.bind(this);
        this.waterChemistryOption = this.waterChemistryOption.bind(this);
    }

    checkboxClick(e) {
        this.props.actions.checkOtherOptions('water_chemistry', e.target.checked)
    }

    checkboxPlusClick(e) {
        this.props.actions.checkOtherOptions('water_chemistry_plus', e.target.checked)
    }

    waterChemistryOption() {
        return this.props.store.other_options.water_chemistry
    }

    render() {
        const water_chemistry_option = this.waterChemistryOption();
        return (
            <div className="row margin-top-sm margin-bottom-md water-chemistry-option">
                <div className="col-sm-2"></div>
                <div className="col-sm-8 text-left">
                    <input
                        className="user-checkbox big-checkbox"
                        id="water_chemistry"
                        value="water_chemistry"
                        type="checkbox"
                        name="other_options[]"
                        onClick={this.checkboxClick}
                    />
                    <span className="option-label">
                        <Tooltip text={tooltipDescriptions.water_chemistry || "Water Chemistry"}>
                            {`Water Chemistry ($${costMappings['water_chemistry']})`}
                        </Tooltip>
                    </span>
                    {
                        water_chemistry_option.checked &&
                        <div className={'water-chem-plus'}>
                            <input
                                className="user-checkbox big-checkbox"
                                id="water_chemistry_plus"
                                value="water_chemistry_plus"
                                type="checkbox"
                                name="other_options[]"
                                onClick={this.checkboxPlusClick}
                            />
                            <span className="option-label">
                                <Tooltip text={tooltipDescriptions.water_chemistry_plus || "Water Chemistry Plus"}>
                                    {`Water Chemistry Plus ($${costMappings['water_chemistry_plus']})`}
                                </Tooltip>
                            </span>
                        </div>
                    }
                    {
                        water_chemistry_option.checked &&
                        <textarea
                            type="text"
                            className='form-input'
                            name={`water_note`}
                            id={`water_note`}
                            placeholder='Your water notes (optional)'
                            rows={5}
                            cols={50}
                        ></textarea>
                    }
                </div>
                <div className="col-sm-2"></div>
            </div>
        );
    }
}

export default WaterChemistryOption